import { Component } from '@angular/core'

@Component({
  selector: 'ftr-reset-sent-page',
  template: '<ftr-reset-sent></ftr-reset-sent>',
  standalone: false,
})
export class ResetSentPage {}
